import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarSimpleRightSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-simple-right-square"><path d="M3.75 3.75H20.25V20.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M15.25 4V20" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconSidebarSimpleRightSquare;
